import React from 'react';
import Modal from 'react-modal';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import TablaHistorial from './TablaHistorial';

Modal.setAppElement('#root');

export default function ModalHistorial({ isOpen, onRequestClose, rowData }) {

    const modalMarginStyle = window.innerWidth > 1280 ?
        { marginLeft: 'calc((100% - 20.5rem) / 3)', marginTop: '13rem' }
        : { margin: '0 auto', marginTop: '7.5rem' };

    return (
        <div className='flex items-center justify-center h-full'>
            <Modal
                className={`bg-gray-100 flex flex-col rounded-lg border-6 w-modal mx-auto h-modal border-orange-500 h-modal-content mb-10`}
                isOpen={isOpen}
                onRequestClose={onRequestClose}
                contentLabel="Ejemplo de Modal"
                style={{
                    overlay: {
                        backgroundColor: '#00000099',
                    },
                    content: {
                        overflowY: "auto",
                        ...modalMarginStyle,
                    },
                }}
            >
                <div className="flex justify-end">
                    <button className="p-1" onClick={onRequestClose}>
                        <AiOutlineCloseCircle className="text-orange-500 hover:bg-orange-600 hover:text-white rounded-full text-4xl mr-1" />
                    </button>
                </div>
                <div className="text-center font-bold text-2xl mb-2">
                    <p>Historial de viajes</p>
                    <TablaHistorial rowData={rowData} />
                </div>
            </Modal>
        </div>
    );
}